import { ICommonIconProps } from './types';
/**
 * -----------------------------------------------------------------------------
 * It renders a ribbon icon with tick mark in the center.
 */
export function QuoteAcceptedIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M11.5 11 10 9.5M14 8.5 11.5 11M8 15h8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M18 3H6a2 2 0 0 0-2 2v14.5a1 1 0 0 0 1.447.894l.771-.386a.998.998 0 0 1 .894 0l1.773.886a.998.998 0 0 0 .894 0l1.773-.886a.998.998 0 0 1 .894 0l1.773.886a1 1 0 0 0 .895 0l1.771-.886a1 1 0 0 1 .895 0l.772.386A1 1 0 0 0 20 19.5V5a2 2 0 0 0-2-2v0Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
